import React from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import { CREATE_PRO_ALLOWANCE_MSG, HAVE_NOT_CREATED_PRO_ALLOWANCES_MSG, } from '../../../constants/response-success-messages';
import { useProAllowance } from '../../../hooks/use-proallowance';
import { ProAllowanceHeader } from '../pro-allowance-header/pro-allowance-header';
export var DeleteProAllowanceConfirmation = function () {
    var _a = useProAllowance(), alertMessage = _a.alertMessage, setAlertMessage = _a.setAlertMessage, checkInactiveButtonStatus = _a.checkInactiveButtonStatus;
    var inactiveButtonStatus = checkInactiveButtonStatus();
    return (React.createElement(React.Fragment, null,
        React.createElement(ProAllowanceHeader, { proAllowacesCount: 0, inactiveButtonStatus: inactiveButtonStatus }),
        alertMessage && (React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Alert, { "data-testid": "middleAlertMsg", onClose: function () { return setAlertMessage(null); }, status: alertMessage.alertStatus }, alertMessage.text))),
        React.createElement(Typography, { weight: "bold" }, HAVE_NOT_CREATED_PRO_ALLOWANCES_MSG.message),
        React.createElement(Typography, null, CREATE_PRO_ALLOWANCE_MSG.message)));
};
DeleteProAllowanceConfirmation.displayName = 'DeleteProAllowanceConfirmation';
